<template>
  <div>
    <el-button size="mini" type="primary" class="addbut" @click="showDialog()" v-if="Permission.indexOf(68)!=-1">
      {{$t('lang.groupinglist.Add')}}
    </el-button>
    <el-button
      type="warning"
      class="addbuts"
      size="mini"
      @click="ShowN2nDialog"
      v-if="Permission.indexOf(102)!=-1">{{$t('lang.groupinglist.Migrate')}}
    </el-button>
    <el-button 
      size="mini" 
      type="warning"
      @click="moveGroup"
      v-if="Permission.indexOf(70)!=-1">
      {{$t('lang.groupinglist.mobileGrouping')}}
    </el-button>
    <!--xlsx表格导出-->
    <xlsx v-if="Permission.indexOf(101)!=-1"></xlsx>
<span>{{$t('lang.groupinglist.GroupingLevel')}}：</span> <el-select size="mini" v-model="groupLevel" @change="gropLevelChange">
  <el-option :value="1" :label="$t('lang.groupinglist.firstLevelGrouping')"></el-option>
  <el-option :value="2" :label="$t('lang.groupinglist.secondaryGrouping')"></el-option>
  <el-option :value="3" :label="$t('lang.groupinglist.threelevelgrouping')"></el-option>
</el-select>
     <!--表格-->
    <!-- <p class="tabletitle"></p> -->
    <div style="height:650px;overflow-y:auto;">
      <TableComponent
        ref="groupTable"
        v-if="TableShow"
        :Columns="Columns"
        :ColuumnsButton="ColuumnsButton"
        :seek="seek"
        :RowKey="'group_id'"
        :data="list"
        :lazy="true"
        :tree-props="{children: 'childrens',hasChildren:'group_id'}"
        :ColuumnsButtonWidth="180"
        :DeleteTitle="$t('lang.groupinglist.GroupDef_delete')"
        @GetGroupname="GetGroupname"
        @GetCustomer="GetCustomer"
        @GetUsername="GetUsername"
        @GetGroupType="GetGroupType"
        @GetRemotelyUsername="GetRemotelyUsername"
        @GetRemotelyPassword="GetRemotelyPassword"
        @GetRemotelyIp="GetRemotelyIp"
        @handleSelectionChange="handleSelectionChange"
        @sortChange="sortChange"
        @pushgrouping="pushgrouping"
        @modification="modification"
        @deletegrouping="deletegrouping"
      >
      <span slot="customColumn" slot-scope="scope" style="color:#409eff;font-size:15px;">
                    <el-tag v-if="scope.scope.row.n2nInfo.n2nInfoBridge == 0" >{{ $t('lang.ConfigSetting.Disable') }}</el-tag>
                    <el-tag v-else>{{ $t('lang.ConfigSetting.Enable') }}</el-tag>
      </span>
    </TableComponent>
    </div>
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
    <!-- 添加分组模块 -->
    <add-group-dialog ref="addGroup" @queryKeyword='queryKeyword' @reFleshTable="reFleshTable"></add-group-dialog>
    <!-- 修改分组模块 -->
    <edit-group-dialog ref="editGroup" @queryKeyword='queryKeyword' @reFleshTable="reFleshTable"></edit-group-dialog>
    <!-- 迁移模块 -->
    <migrate-group-dialog ref="migrateGroup" @queryKeyword='queryKeyword' :N2nidList='N2nidList'></migrate-group-dialog>
    <!-- 移动分组 -->
    <move-group ref="moveGroup" @queryKeyword='queryKeyword' @reFleshTable="reFleshTable" @cancelSelect="cancelSelect"></move-group>
  </div>
</template>

<script>
import { getGroupList, deleteGroup, queryGroupKeyword} from "@/api/groupinglist";
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import { getPermission } from "../../../cookie/cookie";
import { PublicComponent } from "../../../mixins/common";
import { mapGetters } from "vuex";
import TableComponent from '@/components/TableComponent/index'
import { Columns,ColuumnsButton } from "./TableConfig";
import addGroupDialog from './components/addGroup'
import editGroupDialog from './components/editGroup'
import migrateGroupDialog from './components/migrateGroup'
import moveGroup from './components/moveGroup'
export default {
  name:'GroupingList',
  // 分组列表重复修改重复修改多次
  // 注
  // 意
  // 了
  // 如果需要再次修改建议看看接口的数据再来修改。
  mixins: [PublicComponent],
  data() {
    return {
      Columns:Columns,
      ColuumnsButton:ColuumnsButton,
      //用户权限
      Permission: [],
      list: [],
      //后端返回的分组列表
      queryResult: [],
      //用户选中获取到二级分组列表
      groupList: [],
      // superlink分组
      superlink: 0,
      //搜索输入框绑定值
      seek: {
        group_name: "",
        group_names: "",
        c_name: "",
        groupCreateName: "",
        n2nInfoStatus: "",
        group_username: "",
        group_updatetime: "",
        group_password: "",
        edge_ip: "",
        username: ""
      },
      //表格筛选
      sort: {
        groupname: null, //分组名
        parentname: null, //上级分组
        cname: null, //归属客户
        create: null, //创建者
        superlink: null, //服务类型
        account: null, //远程账号
        password: null, //远程密码
        ip: null, //远程ip
        updatetime: null //更新时间
      },
      setsuperlink: null,
      //N2n服务id列表
      N2nidList:[],
      //刷新缓存表格
      TableShow:true,
      // 选择数据
      selections: [],
      groupLevel:1
    };
  },
  mounted() {
    //获取分组列表
    this.getGroupList();
    this.Permission = getPermission();
  },
  methods: {
    ...mapGetters(["GetGroupingName"]),
    showDialog() {
      this.$refs.addGroup.show()
    },
    //修改分组
    modification(row) {
      console.log(row);
      
      this.$refs.editGroup.show(row)
    },
    //删除分组
    deletegrouping(row) {
      let parantId = row.groupPid
      if (row.group_level == 0) {
        this.$message({
          message: this.$t("lang.groupinglist.message10"),
          type: "warning"
        });
        return;
      }
      deleteGroup(row.group_id).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: this.$t("lang.groupinglist.message11"),
            type: "success"
          });
        } else if (res.data.code === 17) {
          this.$message({
            message: this.$t("lang.groupinglist.message10"),
            type: "warning"
          });
        } else {
          this.$message({
            message: this.$t("lang.groupinglist.message12"),
            type: "warning"
          });
        }
        this.queryKeyword();
        this.reFleshTable(parantId)
      });
    },
    //获取分组列表
    getGroupList() {
      console.log('a');
      //获取分组
      getGroupList(this.offset, this.limit).then(res => {        
        if (res.data.data.list.length > 0) {
          this.total = res.data.data.total;
          this.offset = res.data.data.offset;
          this.limit = res.data.data.limit;
          this.list = res.data.data.list
          this.list.unshift({});
        } else if (res.data.data.list.length == 0 && this.offset > 1) {
          this.offset -= 1;          
          getGroupList(this.offset, this.limit).then(res => {
            this.total = res.data.data.total;
            this.offset = res.data.data.offset;
            this.limit = res.data.data.limit;
            this.list = res.data.data.list
            this.list.unshift({});
          });
        }
      });
    },
    //跳转设备
    pushgrouping(row) {
      //保存用户点击的分组名称至vuex
      // this.$store.commit("setgroup_name", index.group_name)      
      // 分组跳转原来是传的分组id后面改成了传分组gid
      this.$store.dispatch("GetGroupingName", row.group_id);
      //跳转路由
      this.$router.push("/device/devicelist");
    },
    //输入框搜索
    queryKeyword() {
      queryGroupKeyword(
        [
          this.seek.group_name,
          this.seek.group_names,
          this.seek.c_name,
          this.seek.groupCreateName,
          this.seek.n2nInfoStatus,
          this.seek.group_username,
          this.seek.group_password,
          this.seek.edge_ip,
          this.seek.group_updatetime
        ],
        this.offset,
        this.limit,
        this.sort,
        this.groupLevel,
      ).then(res => {
        this.offset = res.data.data.offset;
        this.limit = res.data.data.limit;
        this.total = res.data.data.total;
        this.list = res.data.data.list
        //给获取到的数据添加一条空数据，输入框位置
        this.list.unshift({});
      });
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        groupname: null, //分组名
        parentname: null, //上级分组
        cname: null, //归属客户
        create: null, //创建者
        superlink: null, //服务类型
        account: null, //远程账号
        password: null, //远程密码
        ip: null, //远程ip
        updatetime: null //更新时间
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t("lang.groupinglist.GroupName")) {
        this.sort.groupname = sortlist;
      } else if (label == this.$t("lang.groupinglist.GroupByTests")) {
        this.sort.parentname = sortlist;
      } else if (label == this.$t("lang.groupinglist.belonging")) {
        this.sort.cname = sortlist;
      } else if (label == this.$t("lang.groupinglist.contact_to")) {
        this.sort.cname = sortlist;
      } else if (label == this.$t("lang.groupinglist.Creator")) {
        this.sort.create = sortlist;
      } else if (label == this.$t("lang.groupinglist.services")) {
        this.sort.superlink = sortlist;
      } else if (label == this.$t("lang.groupinglist.account_root")) {
        this.sort.account = sortlist;
      } else if (label == this.$t("lang.groupinglist.RemoteMailboxes")) {
        this.sort.password = sortlist;
      } else if (label == this.$t("lang.groupinglist.IPaux")) {
        this.sort.ip = sortlist;
      } else if (label == this.$t("lang.groupinglist.Update")) {
        this.sort.updatetime = sortlist
      }
    },
    //批量迁移分组n2n服务
    handleSelectionChange(val){
      this.selections = val
      this.N2nidList=[]
      val.forEach((value,index)=>{
        this.N2nidList.push(value.n2nInfo.n2nInfoId)
      })
    },
    //n2n迁移弹框
    ShowN2nDialog(){
      if(this.N2nidList.length<1){
        this.$message({
          showClose: true,
          message: this.$t("lang.groupinglist.message17"),
          type:'warning'
        });
        return
      }      
      this.$refs.migrateGroup.show()
    },
   
    //获取上级分组
    GetGroupname(row){  
      console.log(row);
      return row.pgroupName?row.pgroupName:''
    },
    //获取归属客户
    GetCustomer(row){
      return row.customer?row.customer.c_name:''
    },
    //获取归属用户
    GetUsername(row){
      return row.userGroups[0]?row.userGroups[0].user.username:''
    },
    //获取分组类型
    GetGroupType(row){
      return 'SuperLink'
    },
    //获取远程账号
    GetRemotelyUsername(row){
      return row.n2nInfo?row.n2nInfo.group_username:''
    },
    //获取远程密码
    GetRemotelyPassword(row){
      return row.n2nInfo?row.n2nInfo.group_password:''
    },
    //获取远程IP
    GetRemotelyIp(row){
      return row.n2nInfo?row.n2nInfo.edge_ip:''
    },
    // 刷新表格
    reFleshTable(groupId) {
      this.$refs.groupTable.reFleshTable(groupId)
    },
    // 移动分组
    moveGroup() {
      if(this.selections.length <= 0 ){
        this.$message.warning('请选择分组')
      }else if(this.selections.length > 1) {
        this.$message.warning('只能选择一项分组')
      }else if(this.selections[0].group_level == 0){
        this.$message.warning('默认分组不支持移动')
      }else{
        this.$refs.moveGroup.show(this.selections[0])
      }
     
    },
    // 清除选中状态
    cancelSelect() {
      this.$refs.groupTable.cancelSelect()
    },
    gropLevelChange(){
      this.queryKeyword()
    }
  },
  components: {
    pagination,
    xlsx,
    TableComponent,
    addGroupDialog,
    editGroupDialog,
    migrateGroupDialog,
    moveGroup
  },
};
</script>

<style scoped>
.addbut {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
.addbuts{
  margin: 0.2rem 0.2rem 0.2rem 0.2rem;
}
.tetxp {
  display: inline-block;
  width: 1.8rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.el-table__row--level-1 {
  background-color: azure !important;
}
.admininput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}
</style>
